// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19quy","badges":"styles_badges__3EC3A"};